<template>
    <div class="bottom-footer">
      <div class="container-top">
        <div class="content">
          <div class="us">
            <router-link to="/about/story">关于合美</router-link>
            <router-link to="/setmeal">月子套餐</router-link>            <router-link to="/describe">六大服务</router-link>
            <router-link to="/advantage">合美特色</router-link>
            <router-link to="/praise">口碑见证</router-link>
            <router-link to="/dynamic">最新动态</router-link>
          </div>
          <hr>
          <div class="contect-msg">
            <p class="welcome">合美，为母婴提供一站式的产后专业护理可提前预约参观体验、免费月子餐</p>
            <div class="contect-style">
              <span>24小时咨询：陆女士 13921031020</span>
              <span>咨询电话：0519--86957666</span>
              <span>联系邮箱：582515087@qq.com</span>
              <span>地址：常州市武进区武宜南路698号-15号</span>
            </div>
            <div class="erweima">
              <img src="../../../static/img/index/erweima.png" alt="">
              <p>扫一扫  领优惠</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container-bottom">
        <div class="content">
          <ul>
            <li class="back-item">
              ©2023 常州市盈能电气有限公司技术支持
            </li>
            <router-link to="" tag="li" class="back-item">
              网站地图
            </router-link>
            <li class="back-item"><a style="color:#DEC2A7;" href="https://beian.miit.gov.cn" target="_blank">苏ICP备08014420号-4 </a></li>
          </ul>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "bottom-footer"
    }
</script>

<style scoped lang="less">
.bottom-footer{
  height: 233px;
  width: 100%;
  .container-top{
    height: 192px;
    width: 100%;
    background-color: #906236;
    .us{
      a{
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        color:#ffffff;
        margin-right: 70px;
      }
    }
    hr{
      background-color: #9b7149;
      border: none;
      height: 1px;
      margin-bottom: 20px;
    }
    .contect-msg{
      font-size: 14px;
      color:#ffffff;
      line-height: 28px;
      position: relative;
      .welcome{
        margin-bottom: 12px;
      }
      .contect-style{
        width: 800px;
        span{
          float: left;
          margin-right: 70px;
          &:nth-child(3){
            margin-right: 0;
          }
        }
      }
      .erweima{
        width: 89px;
        position: absolute;
        right: 0;
        top: 0;
        img{
          display: block;
          margin:0 auto;
          width: 79px;
          height: 79px;
        }
        p{
          color:#ffffff;
          font-size: 14px;
        }
      }
    }
  }
  .container-bottom{
    width: 100%;
    height: 41px;
    background-color: #855b32;
    .content{
      padding: 13px 0;
      .back-item{
        cursor: pointer;
        float: left;
        color:#DEC2A7;
        padding-right: 20px;
        border-right: 1px solid #DEC2A7;
        margin-right: 20px;
        font-size: 14px;
        line-height: 14px;
      }
    }
  }

  .under-label{
    margin-top: 15px;
    color:#9b786e;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue